import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { GlobalLoadingService } from '../services/global-loading.service';

/**
 * Global loading interceptor
 * - Shows loader immediately when a non-GET HTTP request starts
 * - Hides loader when the request completes (success or error)
 * - Uses an internal counter to handle concurrent requests correctly
 */
export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const globalLoadingService = inject(GlobalLoadingService);

  const isMutating = req.method !== 'GET';

  if (isMutating) {
    // Show global loader immediately on action start
    globalLoadingService.setLoading();
  }

  return next(req).pipe(
    finalize(() => {
      if (isMutating) {
        globalLoadingService.clearLoading();
      }
    })
  );
};


